import styles from "./TrustedBy.module.css";

interface FeaturedIn {
  name: string;
  href?: string;
}

const FEATURED_IN: FeaturedIn[] = [
  { name: "Vogue", href: "https://www.vogue.com/" },
  { name: "Allure", href: "https://www.allure.com/" },
  { name: "The Cut", href: "https://www.thecut.com/" },
  { name: "Coveteur", href: "https://www.coveteur.com/" },
  { name: "Refinery29", href: "https://www.refinery29.com/" },
  { name: "Into The Gloss", href: "https://intothegloss.com/" },
];

export function TrustedBy() {
  return (
    <div className={`container-wide ${styles.wrap}`}>
      <p className={styles.label} id="trusted-by-label">
        As featured in
      </p>
      <ul className={styles.row} aria-labelledby="trusted-by-label">
        {FEATURED_IN.map((item) => (
          <li key={item.name} className={styles.item}>
            {item.href ? (
              <a
                className={styles.wordmark}
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`${item.name} (opens in new tab)`}
              >
                {item.name}
              </a>
            ) : (
              <span className={styles.wordmark} aria-hidden="true">
                {item.name}
              </span>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}